import React, {Component} from 'react';
import * as func from "../../../../../utils/functions";
import {MESSAGE, EDIT_MODE} from "../../../../../wpconfig"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLink} from "@fortawesome/free-solid-svg-icons";

class NamesItem extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isEdit: this.props.record.is_edit ? EDIT_MODE.SHOW_EDIT : EDIT_MODE.SHOW,
			record: func.deepClone(this.props.record),
			field: 'journal_title',
			name: '아이디',
			id: 'title_value'
		}
	}

	change = () => {
		const record = this.props.record;
		record[event.target.name] = event.target.value;
		this.props.onUpdate(this.props.arrIndex, this.props.record, true);
	}

	onEditSave = (event) => {
		event.preventDefault()

		let isEdit = '';
		if (this.state.isEdit === EDIT_MODE.SHOW) {
			isEdit = EDIT_MODE.SHOW_EDIT;
		} else if (this.state.isEdit === EDIT_MODE.SHOW_EDIT) {
			isEdit = EDIT_MODE.SAVE_EDIT;
		}
		if (isEdit === EDIT_MODE.SAVE_EDIT) {
			if (this.props.record[this.props.pkKey]) {
				func.updateData("admin/" + this.state.field + "/" + func.getParams("record_id") + "/update", this.props.record).then((response) => {
					if (response.code === 'ok') {
						isEdit = EDIT_MODE.SHOW;
						this.setState({record: func.deepClone(this.props.record)})
						this.props.showMessage('수정 되었습니다.');
					} else {
						this.props.showMessage('수정 실패 : ' + response.message)
						isEdit = EDIT_MODE.SHOW_EDIT;
					}
					this.setState({'isEdit': isEdit});
				});
			} else {
				let record = this.props.record;
				if (this[this.state.id].value === '') {
					this[this.state.id].focus();
				} else {
					delete record.is_edit;
					func.updateData("admin/" + this.state.field + "/" + func.getParams("record_id") + "/insert", record).then((response) => {
						if (response.code === 'ok') {
							isEdit = EDIT_MODE.SHOW;
							this.setState({'isEdit': isEdit});
							record[this.props.pkKey] = response[this.props.pkKey];
							this.props.onUpdate(this.props.arrIndex, record, true);
							this.props.showMessage('추가 되었습니다.');
						} else {
							this.props.showMessage('저장 실패 : ' + response.message);
						}
					});
				}
			}
		} else {
			this.props.onEditIndex(this.props.index)
			this.setState({'isEdit': EDIT_MODE.SHOW_EDIT});
		}
	};

	onCloseDelete = (event) => {
		event.preventDefault()

		const record = this.props.record;
		if (record[this.props.pkKey]) {
			if (this.state.isEdit) {
				this.setState({'isEdit': EDIT_MODE.SHOW});
				this.props.onUpdate(this.props.arrIndex, func.deepClone(this.state.record), true);
			} else {
				if (confirm(record[this.state.id] + ' ' + this.state.name + '를 ' + MESSAGE.DELETE)) {
					let record = this.props.record;
					func.updateData("admin/" + this.state.field + "/" + func.getParams("record_id") + "/delete", record).then((response) => {
						if (response.code === 'ok') {
							this.props.showMessage('삭제 되었습니다.');
							this.props.onRemove(this.props.arrIndex)
						} else {
							this.props.showMessage('삭제 실패 : ' + response.message)
						}
					});
				}
			}
		} else {
			this.setState({'isEdit': EDIT_MODE.SHOW});
			this.props.onRemove(this.props.index)
		}
	}

	onClose = (e) => {
		this.setState({'isEdit': EDIT_MODE.SHOW});
		if (this.props.record[this.props.pkKey]) {
			this.props.onUpdate(this.props.arrIndex, func.deepClone(this.state.record), true);
		} else {
			this.props.onRemove(this.props.arrIndex)
		}
	};

	render() {
		const record = this.props.record;

		return (
			<>
				{this.state.isEdit === EDIT_MODE.SHOW ?
					<tr className="list-row">
						<td className="column-id-type">
							<label className="mt-2">{this.props.categoryName[record.title_type]}</label>
						</td>
						<td className="column-id-value">
							<label className="mt-2">{record.title_value}</label>
						</td>
						<td className="column-action">
							<div className="btn-group">
								<button className="btn btn-outline-success btn-sm insert"
										onClick={this.onEditSave}>{record[this.props.pkKey] ? '수정' : '저장'}</button>
								<button className="btn btn-outline-danger btn-sm cancel" onClick={this.onCloseDelete}>삭제</button>
							</div>
						</td>
					</tr>
					:
					<tr className="list-row">
						<td>
							<select className="form-control form-control-sm"
							        defaultValue={record.title_type}
							        ref={(ref) => this.title_type = ref}
							        name="title_type"
							        onChange={this.change}>
								{this.props.category.map((type, i) => {
									return (<option key={type.code_id} value={type.code_id}>{type.code_name}</option>)
								})}
							</select>
						</td>
						<td>
							<input type="text" name="title_value"
							       ref={(ref) => this.title_value = ref}
							       className="form-control-sm large-text" defaultValue={record.title_value}
							       onKeyUp={this.change}/>
						</td>
						<td>
							<div className="btn-group">
								<button className="btn btn-outline-primary btn-sm insert" onClick={this.onEditSave}>저장</button>
								<button className="btn btn-outline-secondary btn-sm cancel" onClick={this.onCloseDelete}>닫기</button>
							</div>
						</td>
					</tr>
				}
			</>
		)
	}
}

export default NamesItem;